export const fadeEnd = {
  scale: 1,
  translateY: 1,
  opacity: 1,
};

export const fadeStart = {
  scale: 0.9,
  translateY: -20,
  opacity: 0,
};

export const containerVariants = {
  hidden: fadeStart,
  show: {
    ...fadeEnd,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const itemVariants = {
  hidden: fadeStart,
  show: fadeEnd,
};
